import HeaderSection from '@/common/components/HeaderSection.vue';
import FinishedPageDialog from '@/common/components/FinishedPageDialog.vue';
import Loader from '@/common/components/Loader.vue';
import OsaFooter from '@/common/components/OsaFooter.vue';
import PageTitle from '@/common/components/PageTitle.vue';
import CustomerSelectedInformation from '@/common/components/CustomerSelectedInformation.vue';
import MessageSpecialSituation from '@/common/components/MessageSpecialSituation.vue';
import Editor from '@/common/components/MdEditor/Editor.vue';
import Viewer from '@/common/components/MdEditor/Viewer.vue';

export {
    HeaderSection,
    FinishedPageDialog,
    Loader,
    OsaFooter,
    PageTitle,
    CustomerSelectedInformation,
    MessageSpecialSituation,
    Editor,
    Viewer
}
